import { type CombinedError } from 'urql';

import { type OperationState } from '@/src/integrations/urql';
import { logger } from '@/src/internal/logger';

import { GraphqlNetworkError, GraphQLResponseError } from './errors';

/**
 * @deprecated
 * Deprecated in favor of {@link parseUrqlHttpErrors} in @/src/integrations/urql/errors.  The
 * actual logging occurs within the {@link createMutationHook} factory hook.
 */
export const logGraphqlErrorsToClientErrorLogger = (
  message: string,
  error: CombinedError,
  operationState: Omit<OperationState, 'error'>,
): void => {
  if (error.graphQLErrors.length > 0) {
    error.graphQLErrors.forEach(graphQLError => {
      logger.error(new GraphQLResponseError(message, graphQLError), {
        error,
        ...operationState,
      });
    });
  } else if (error.networkError) {
    logger.error(new GraphqlNetworkError(message, error.networkError), {
      error,
      ...operationState,
    });
  } else {
    logger.error(new GraphQLResponseError(message, error), {
      error,
      ...operationState,
    });
  }
};
